import axios from 'axios';

export default {
	name: 'CartaCatalogo',
    data: () => ({
		catalogo: {
            restaurante: [],
            categoria: [],
            visibilidad: []
        }
	}),
	methods: {
		getCatalogo (lista) {
			axios
			.get(this.UrlBase + '/catalogo/get_lista?format=json', {params: {lista:lista}})
			.then(r => {
				if (r.data.exito) {
                    for (let i in r.data.lista) {
                        this.catalogo[i] = r.data.lista[i];
                    }
				} else {
					alert(r.data.mensaje);
				}
			})
			.catch(e => {
				alert(e);
			});
		}
	}
}